import { render, staticRenderFns } from "./CanvasSidebar.vue?vue&type=template&id=0405415a&scoped=true&"
import script from "./CanvasSidebar.vue?vue&type=script&lang=ts&"
export * from "./CanvasSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasSidebar.vue?vue&type=style&index=0&id=0405415a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405415a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
